import React, { useEffect, useState } from 'react'
import { useGetMintingReward } from '../../../../hooks/useOtherCollections'
import Api from '../../../../services/Api'
import RankData from './data/AvaPepeData.json'
import { INFDetailFormatted } from '../../components/NFTDetail/INFTDetail'
import NFTImageSkeleton from '../../components/NFTImageSkeleton'
import { NFTPropertyItem } from '../../components/NFTProperty'
import { RarityClass, AvaPepRarity } from '../../data/NFTCollections/AvaPepesData'
import { IBaseNFTAttributes } from '../../models/INFTProperties'
import { IGeneralCard } from '../Cards/GeneralCard'
import BaseDetail from './BaseDetail'


export default function AvaPepeDetail(props: INFDetailFormatted) {
  const { tokenItem, collection } = props
  const [detailTokenItem, setDetailTokenItem] = useState<IGeneralCard | null>(null)
  const [tokenUriControl, setTokenUriControl] = useState<boolean>(false)
  let foundedRarityClass: { bgColor: string; percent: string } | undefined = undefined

  let tokenName = detailTokenItem && detailTokenItem.name ? detailTokenItem.name : collection.name

  if (detailTokenItem && !detailTokenItem.name) {
    tokenName = detailTokenItem ? `${collection.name} #${tokenItem.tokenId}` : collection.name
  }

  if (detailTokenItem && detailTokenItem.attributes) {
    const foundClass = detailTokenItem.attributes.find(item => item.trait_type === 'Class')
    if (foundClass) {
      foundedRarityClass = RarityClass[foundClass.value]
    }
  }

  let mintingReward = '0'

  const pepeId = tokenItem ? tokenItem.tokenId : 0
  mintingReward = useGetMintingReward(pepeId)

  useEffect(() => {
    if (tokenItem && tokenItem.tokenId !== undefined && tokenItem.tokenUri && !tokenUriControl) {
      setTokenUriControl(true)
      Api.get(tokenItem.tokenUri).then((tokenResult: any) => setDetailTokenItem(tokenResult))
    }
  }, [tokenItem, tokenUriControl])

  function getNFTProperties() {
    let result: any[] = []
    let total = 0

    if (detailTokenItem && detailTokenItem.attributes) {
      const foundRank = tokenItem ? RankData.find((item: any) => parseInt(tokenItem.tokenId.toString()) === item.Pepe) : null
      result = detailTokenItem.attributes
        .filter(item => item.value)
        .map((item: IBaseNFTAttributes, index: number) => {
          const foundRarity = AvaPepRarity[item.trait_type]
          let rarityScore: string | number = foundRarity ? foundRarity[item.value] : 0
          total += rarityScore

          if (item.trait_type === 'Class') {
            rarityScore = RarityClass[item.value]?.percent
          }

          return (
            <NFTPropertyItem key={`PROPERTY_${index}`} className={`property-item`}>
              <div className="wrapper">
                <div className="type" title={item.trait_type}>
                  {item.trait_type}
                </div>
                <div className="name" title={item.value}>
                  <div>
                    {item.value} {rarityScore !== 0 ? `(${rarityScore})` : ''}
                  </div>
                </div>
              </div>
            </NFTPropertyItem>
          )
        })

      result.unshift(
        <NFTPropertyItem key={`PROPERTY_PERCENT_SCORE`} className={`property-item`}>
          <div className="wrapper">
            <div className="type" title="Rarity Score">
              Rarity Score
            </div>
            <div className="name" title={`${total}`}>
              <div>{total}</div>
            </div>
          </div>
        </NFTPropertyItem>
      )

      if (foundRank) {
        result.unshift(
          <NFTPropertyItem key={`PROPERTY_PERCENT_SCORE`} className={`property-item`}>
            <div className="wrapper">
              <div className="type" title="Rank">
                Rank
              </div>
              <div className="name" title={`${foundRank.rarityRank}`}>
                <div>{foundRank.rarityRank}</div>
              </div>
            </div>
          </NFTPropertyItem>
        )
      }

      result.unshift(
        <NFTPropertyItem key={`PROPERTY_MINTING_REWARD`} className={`property-item`}>
          <div className="wrapper">
            <div className="type" title="Minting reward">
              Minting reward
            </div>
            <div className="name" title={mintingReward}>
              <div>{mintingReward}</div>
            </div>
          </div>
        </NFTPropertyItem>
      )
    }

    return result
  }

  return (
    <BaseDetail
      {...props}
      description={
        detailTokenItem ? (
          <div>
            About Avalanche Frens Club
            <p>
              This is your invite! Join the frogs on Avalanche, an exclusive pepe frens club with 10.000 unique
              generative AvaPepes.
            </p>
            <p>AvaPepe has 160+ unique attributes that will come together to make your pepe look awesome.</p>
          </div>
        ) : (
          undefined
        )
      }
      tokenItemName={tokenName}
      externalUrl={detailTokenItem?.externalUrl}
      customProperties={getNFTProperties()}
      detailItemCustomStyle={foundedRarityClass ? { backgroundImage: foundedRarityClass.bgColor } : undefined}
    >
      {detailTokenItem ? <img src={detailTokenItem.image} alt={tokenName} /> : <NFTImageSkeleton />}
    </BaseDetail>
  )
}
